import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import {handleListResponse, handleError} from '@/services/amio-api/utils/request-utils'
import merge from 'ramda/src/merge'

class EventService {
  constructor() {
    this.path = '/events'
  }

  list(params = {}, ignoredHttpStatuses = []) {
    const _params = merge({offset: 0, max: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(this.path, {
        params: _params
      })
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new EventService()
